<template>
<div>
    <v-dialog v-model="dialogproject" max-width="450px">
        <v-toolbar dark color="primary">

            <v-toolbar-title>{{parmVariablename}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn icon dark @click="dialogproject = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-simple-table>
            <template v-slot:default>

                <tbody>
                    <tr v-for="item in Itemgrd" :key="item.name">
                        <td>{{ item.name }}</td>
                        <td class="text-right">{{String(item.value)|trgm_numberformate}}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-dialog>

</div>
</template>

<script>
import numeral from 'numeral';
//import {bus} from '../../../main';
import apifactory from '../api';
import {
    defineComponent
} from '@vue/composition-api'

export default defineComponent({
    data: () => ({

        AdjustedRsquared: '',
        dialogproject: false,
        parmVariablename: '',
        Itemgrd: [],
        volume: '',
        volume_contribution: '',
        volume_response: '',
        roi: '',

        desserts: [{
                name: 'Frozen Yogurt',
                calories: 159,
            },
            {
                name: 'Ice cream sandwich',
                calories: 237,
            },
            {
                name: 'Eclair',
                calories: 262,
            },
            {
                name: 'Cupcake',
                calories: 305,
            },
            {
                name: 'Gingerbread',
                calories: 356,
            },
            {
                name: 'Jelly bean',
                calories: 375,
            },
            {
                name: 'Lollipop',
                calories: 392,
            },
            {
                name: 'Honeycomb',
                calories: 408,
            },
            {
                name: 'Donut',
                calories: 452,
            },
            {
                name: 'KitKat',
                calories: 518,
            },
        ],
    }),
    methods: {

        getdata() {

            this.Itemgrd = [];
            apifactory.get_model_roi_table()
                .then((res) => {
                    // alert(res.id);

                    if (res.status != 200) {
                        //this.countryList = null;
                        alert(res.message);

                    } else {

                        for (var i = 0; i < res.data.length; i++) {
                            if (res.data[i].variable === this.parmVariablename) {
                                let objvolume = new Object();
                                objvolume.name = "Volume";
                                objvolume.value = JSON.stringify(res.data[i].volume);

                                let objvolume_contribution = new Object();
                                objvolume_contribution.name = "Volume Contribution";
                                objvolume_contribution.value = JSON.stringify(res.data[i].volume_contribution) + " %";

                                let objvolume_response = new Object();
                                objvolume_response.name = "Volume Response";
                                objvolume_response.value = JSON.stringify(res.data[i].volume_response);

                                let objroi = new Object();
                                objroi.name = "ROI";
                                objroi.value = JSON.stringify(res.data[i].roi);

                                this.Itemgrd.push(objvolume);
                                this.Itemgrd.push(objvolume_contribution);
                                this.Itemgrd.push(objvolume_response);
                                this.Itemgrd.push(objroi);
                            }
                        }
                        // alert( this.Itemgrd.length);
                        let havedata = 0;
                        havedata = this.Itemgrd.length;
                        if (havedata > 0) {
                            this.dialogproject = true;
                        } else {
                            alert('No Data');
                        }

                        //this.ItemListmodeldepvarlist = [...Object.keys(res.data)]

                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        formatedatavalue(value) {
            let newval = String(value);
            let temarray = newval.split('.');
            let formatestr = numeral(temarray[0]).format('0,0');
            let result = formatestr;
            if (temarray.length > 1) {
                result = result + "." + temarray[1]
            }

            return `${result}`;
        },
        Refresh(varname) {

            alert('coffdatavuewrefresh' + varname);

            this.parmVariablename = varname;
            this.dialogproject=true;
            this.getdata();
        }
    },
    mounted() {

        //this.getadj_rsquared();
       // bus.$off('coffdatavuewrefresh');
       // bus.$on('coffdatavuewrefresh', this.Refresh);
    }
})
</script>

<style scoped>
.headerbox {
    font-weight: bold;
    font-style: italic;
    font-size: 25px;
    color: black;

}

.headerboxtitle {

    font-size: 20px;
}

.card2 {
    background-color: #FFFF00;
}
</style>
